import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { sessionInterceptor } from './core/session.interceptor';
import { ApiModule, BASE_PATH } from '../api';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RuntimeConfigService } from './core/runtime-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), 
    provideClientHydration(), 
    provideHttpClient(withInterceptors([sessionInterceptor])), 
    ApiModule, 
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [RuntimeConfigService],
      useFactory: (config: RuntimeConfigService) => () => config.load()
    },
    {
      provide: BASE_PATH,
      deps: [RuntimeConfigService],
      useFactory: (config: RuntimeConfigService) => config.apiBasePath
    }
  ]
};
